import { ArrowRight } from 'lucide-react';

import avatar1 from '@/assets/landing/avatar-1.webp';
import avatar2 from '@/assets/landing/avatar-2.webp';
import avatar3 from '@/assets/landing/avatar-3.webp';

import { HeroDashboard } from './hero-dashboard';

export function HeroSection() {
  return (
    <section
      aria-labelledby="lp-hero-title"
      className="lp-hero-bg relative overflow-hidden pt-[124px] sm:pt-[148px]"
    >
      <div className="mx-auto max-w-[1180px] px-5 text-center sm:px-6">
        <span className="border-(--lp-line) text-(--lp-body) inline-flex items-center gap-2.5 rounded-full border bg-white/80 py-1 pl-1 pr-4 text-[13px] backdrop-blur">
          <span className="flex -space-x-2">
            {[avatar1, avatar2, avatar3].map((src) => (
              <img
                key={src}
                src={src}
                alt=""
                width="28"
                height="28"
                className="size-7 rounded-full border-2 border-white object-cover"
              />
            ))}
          </span>
          Para advocacia autônoma e escritórios
          <span className="hidden sm:inline">de todos os tamanhos</span>
        </span>

        <h1
          id="lp-hero-title"
          className="text-(--lp-ink) mx-auto mt-7 max-w-[860px] text-balance text-[clamp(40px,6.4vw,72px)] font-medium leading-[1.04] tracking-[-0.045em]"
        >
          O CRM jurídico que deixa seu escritório <span className="lp-gradient-text">em dia</span>
        </h1>

        <p className="text-(--lp-body) mx-auto mt-6 max-w-[600px] text-pretty text-[17px] leading-relaxed sm:text-lg">
          Publicações, prazos, clientes, documentos e honorários em um só lugar. Simples de usar e
          feito para a rotina da advocacia.
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="/criar-conta"
            className="bg-primary inline-flex h-12 w-full items-center justify-center gap-2 rounded-xl px-6 text-[15px] font-medium text-white shadow-[inset_0_1px_0_rgb(255_255_255/0.18),0_10px_24px_-10px_rgb(12_80_227/0.55)] transition-transform hover:-translate-y-px sm:w-auto"
          >
            Criar conta gratuita <ArrowRight size={17} />
          </a>
          <a
            href="#recursos"
            className="border-(--lp-line) text-(--lp-ink) hover:bg-(--lp-soft) inline-flex h-12 w-full items-center justify-center rounded-xl border bg-white px-6 text-[15px] font-medium transition-colors sm:w-auto"
          >
            Ver os recursos
          </a>
        </div>
      </div>

      <div className="relative mx-auto mt-10 max-w-[1180px] px-3 sm:px-6">
        <HeroDashboard />
        {/* O painel some no branco da seção seguinte em vez de terminar numa borda. */}
        <div
          aria-hidden="true"
          className="bg-linear-to-b absolute inset-x-0 bottom-0 h-40 from-transparent to-white"
        />
      </div>
    </section>
  );
}
